module.exports = function (t) {
  var e = {};
  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }
  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) n.d(r, o, function (e) {
      return t[e];
    }.bind(null, o));
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 1);
}([function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.AbstractSingleton = void 0;
  var r,
    o,
    i,
    a = function t() {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t);
      var e = this.constructor.name;
      if ("AbstractSingleton" === this.constructor.name) throw new TypeError("Abstract class '".concat(e, "' cannot be instantiated on its own."));
      if (this.constructor._instance) return this.constructor._instance;
      this.constructor._instance = this;
    };
  e.AbstractSingleton = a, i = void 0, (o = "_instance") in (r = a) ? Object.defineProperty(r, o, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[o] = i;
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "AbstractAuthentication", {
    enumerable: !0,
    get: function get() {
      return r.AbstractAuthentication;
    }
  }), Object.defineProperty(e, "AbstractDocument", {
    enumerable: !0,
    get: function get() {
      return o.AbstractDocument;
    }
  }), Object.defineProperty(e, "AbstractEnum", {
    enumerable: !0,
    get: function get() {
      return i.AbstractEnum;
    }
  }), Object.defineProperty(e, "AbstractList", {
    enumerable: !0,
    get: function get() {
      return a.AbstractList;
    }
  }), Object.defineProperty(e, "AbstractParser", {
    enumerable: !0,
    get: function get() {
      return s.AbstractParser;
    }
  }), Object.defineProperty(e, "AbstractRequestHandler", {
    enumerable: !0,
    get: function get() {
      return c.AbstractRequestHandler;
    }
  }), Object.defineProperty(e, "AbstractSingleton", {
    enumerable: !0,
    get: function get() {
      return u.AbstractSingleton;
    }
  }), Object.defineProperty(e, "AbstractStore", {
    enumerable: !0,
    get: function get() {
      return l.AbstractStore;
    }
  }), Object.defineProperty(e, "AbstractValidation", {
    enumerable: !0,
    get: function get() {
      return f.AbstractValidation;
    }
  });
  var r = n(2),
    o = n(3),
    i = n(4),
    a = n(5),
    s = n(6),
    c = n(7),
    u = n(0),
    l = n(8),
    f = n(9);
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.AbstractAuthentication = void 0;
  e.AbstractAuthentication = function t() {
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t);
    var e = this.constructor.name;
    if ("AbstractAuthentication" === this.constructor.name) throw new TypeError("Abstract class '".concat(e, "' cannot be instantiated on its own."));
    for (var n = [["authenticate", "user"], ["logout", null], ["status", null]], r = 0; r < n.length; r++) {
      var o = n[r];
      if (void 0 === this[o[0]]) throw o[1] || (o[1] = ""), new TypeError("Classes extending '".concat(e, "' must declare the '").concat(o[0], "(").concat(o[1], ")' method."));
      this[o[0]] = this[o[0]].bind(this);
    }
  };
}, function (t, e, n) {
  "use strict";

  function r(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function o(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.AbstractDocument = void 0;
  var i = function () {
    function t(e, n) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), o(this, "_input", null), o(this, "_length", null);
      var r = this.constructor.name;
      if ("AbstractDocument" === this.constructor.name) throw new TypeError("Abstract class '".concat(r, "' cannot be instantiated on its own."));
      for (var i = [["format", null], ["validate", null]], a = 0; a < i.length; a++) {
        var s = i[a];
        if (void 0 === this[s[0]]) throw s[1] || (s[1] = ""), new TypeError("Classes extending '".concat(r, "' must declare the '").concat(s[0], "(").concat(s[1], ")' method."));
        this[s[0]] = this[s[0]].bind(this);
      }
      this._input = e, this._length = n;
    }
    var e, n, i;
    return e = t, (n = [{
      key: "toJSON",
      value: function value() {
        var t = !!this.hasOwnProperty("validate") && this.validate(),
          e = this.hasOwnProperty("format") ? this.format() : "";
        return {
          value: this.input || "",
          formattedValue: e || "",
          isValid: t || !1
        };
      }
    }, {
      key: "toString",
      value: function value() {
        return "[object ".concat(this.constructor.name, "]");
      }
    }, {
      key: "input",
      get: function get() {
        return this._input;
      },
      set: function set(t) {
        this._input = t;
      }
    }, {
      key: "length",
      get: function get() {
        return this._length;
      },
      set: function set(t) {
        this._length = t;
      }
    }]) && r(e.prototype, n), i && r(e, i), t;
  }();
  e.AbstractDocument = i;
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.AbstractEnum = void 0;
  var r = n(0);
  function o(t) {
    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function i(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function a(t) {
    return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function s(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function c(t, e) {
    return (c = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var u = function (t) {
    function e(t) {
      var n, r, i;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), r = this;
      var c = (n = !(i = a(e).call(this)) || "object" !== o(i) && "function" != typeof i ? s(r) : i).constructor.name;
      if ("AbstractEnum" === n.constructor.name) throw new TypeError("Abstract class '".concat(c, "' cannot be instantiated on its own."));
      if (0 === Object.keys(s(n)).length) for (var u = 0, l = Object.keys(t); u < l.length; u++) {
        var f = l[u];
        if (void 0 !== n[f] && (Object.keys(s(n)).indexOf(f) > -1 || Object.keys(s(n)).indexOf(t[f]) > -1)) throw new TypeError("Enum keys and values must be distinct.");
        n[f] = t[f];
      }
      return n;
    }
    var n, u, l;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && c(t, e);
    }(e, r.AbstractSingleton), n = e, (u = [{
      key: "get",
      value: function value(t) {
        var e = this;
        return this._isValid(t) ? Object.keys(this).find(function (n) {
          return e[n] === t;
        }) : "UNKNOWN";
      }
    }, {
      key: "getKeys",
      value: function value() {
        return Object.keys(this);
      }
    }, {
      key: "getValues",
      value: function value() {
        if (Object.hasOwnProperty("values")) return Object.values(this);
        for (var t = Object.keys(this), e = [], n = 0; n < t.length; n++) void 0 !== t[n] && e.push(this[t[n]]);
        return e;
      }
    }, {
      key: "toJSON",
      value: function value() {
        for (var t = {}, e = Object.keys(this), n = 0; n < e.length; n++) void 0 !== this[e[n]] && (t[e[n]] = this[e[n]]);
        return t;
      }
    }, {
      key: "toString",
      value: function value() {
        return "[object ".concat(this.constructor.name, "]");
      }
    }, {
      key: "_isValid",
      value: function value(t) {
        return Object.values(this).indexOf(t) > -1;
      }
    }]) && i(n.prototype, u), l && i(n, l), e;
  }();
  e.AbstractEnum = u;
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.AbstractList = void 0;
  var r = n(0);
  function o(t) {
    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function i(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function a(t) {
    return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function s(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function c(t, e) {
    return (c = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var u = function (t) {
    function e(t) {
      var n, r, i;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), r = this, i = a(e).call(this);
      var c = (n = !i || "object" !== o(i) && "function" != typeof i ? s(r) : i).constructor.name;
      if ("AbstractList" === n.constructor.name) throw new TypeError("Abstract class '".concat(c, "' cannot be instantiated on its own."));
      if (0 === Object.keys(s(n)).length) for (var u = function u() {
          var e = f[l],
            r = t[e],
            o = Object.values(s(n)).filter(function (t) {
              return t.id === r.id || t.name === r.name || t.slug === r.slug;
            });
          if (!r.hasOwnProperty("id") || !r.hasOwnProperty("name") || !r.hasOwnProperty("slug")) throw new TypeError("'".concat(c, "' items must have an 'id', 'name' and 'slug' properties."));
          if (void 0 !== n[e] && o.length > 0) throw new TypeError("'".concat(c, "' items must be distinct."));
          n[e] = r;
        }, l = 0, f = Object.keys(t); l < f.length; l++) u();
      return n;
    }
    var n, u, l;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && c(t, e);
    }(e, r.AbstractSingleton), n = e, (u = [{
      key: "getIdByKey",
      value: function value(t) {
        return this._getBy("id", "key", t);
      }
    }, {
      key: "getIdByName",
      value: function value(t) {
        return this._getBy("id", "name", t);
      }
    }, {
      key: "getIdBySlug",
      value: function value(t) {
        return this._getBy("id", "slug", t);
      }
    }, {
      key: "getNameById",
      value: function value(t) {
        return t = "string" == typeof t ? parseInt(t) : t, this._getBy("name", "id", t);
      }
    }, {
      key: "getNameBySlug",
      value: function value(t) {
        return this._getBy("name", "slug", t);
      }
    }, {
      key: "getNameByKey",
      value: function value(t) {
        return this._getBy("name", "key", t);
      }
    }, {
      key: "getSlugById",
      value: function value(t) {
        return t = "string" == typeof t ? parseInt(t) : t, this._getBy("slug", "id", t);
      }
    }, {
      key: "getSlugByName",
      value: function value(t) {
        return this._getBy("slug", "name", t);
      }
    }, {
      key: "getSlugByKey",
      value: function value(t) {
        return this._getBy("slug", "key", t);
      }
    }, {
      key: "getKeyById",
      value: function value(t) {
        return t = "string" == typeof t ? parseInt(t) : t, this._getBy("key", "id", t);
      }
    }, {
      key: "getKeyByName",
      value: function value(t) {
        return this._getBy("key", "name", t);
      }
    }, {
      key: "getKeyBySlug",
      value: function value(t) {
        return this._getBy("key", "slug", t);
      }
    }, {
      key: "getObjectById",
      value: function value(t) {
        return this._getBy("object", "id", t);
      }
    }, {
      key: "getObjectByName",
      value: function value(t) {
        return this._getBy("object", "name", t);
      }
    }, {
      key: "getObjectBySlug",
      value: function value(t) {
        return this._getBy("object", "slug", t);
      }
    }, {
      key: "getObjectByKey",
      value: function value(t) {
        return this._getBy("object", "key", t);
      }
    }, {
      key: "toJSON",
      value: function value() {
        for (var t = {}, e = Object.keys(this), n = 0; n < e.length; n++) void 0 !== this[e[n]] && (t[e[n]] = this[e[n]]);
        return t;
      }
    }, {
      key: "toString",
      value: function value() {
        return "[object ".concat(this.constructor.name, "]");
      }
    }, {
      key: "_getBy",
      value: function value(t, e, n) {
        var r = Object.keys(this);
        for (var o in r) {
          var i = r[o],
            a = this[i],
            s = !1;
          if ("id" === t) {
            switch (e) {
              case "name":
                s = a.name === n;
                break;
              case "slug":
                s = a.slug === n;
                break;
              default:
                s = i === n;
            }
            if (!0 === s) return a.id;
          } else if ("name" === t) {
            switch (e) {
              case "id":
                s = a.id === n;
                break;
              case "slug":
                s = a.slug === n;
                break;
              default:
                s = i === n;
            }
            if (!0 === s) return a.name;
          } else if ("slug" === t) {
            switch (e) {
              case "id":
                s = a.id === n;
                break;
              case "name":
                s = a.name === n;
                break;
              default:
                s = i === n;
            }
            if (!0 === s) return a.slug;
          } else if ("key" === t) {
            switch (e) {
              case "id":
                s = a.id === n;
                break;
              case "name":
                s = a.name === n;
                break;
              case "slug":
                s = a.slug === n;
            }
            if (!0 === s) return i;
          } else if ("object" === t) {
            switch (e) {
              case "id":
                s = a.id === n;
                break;
              case "name":
                s = a.name === n;
                break;
              case "slug":
                s = a.slug === n;
                break;
              default:
                s = i === n;
            }
            if (!0 === s) return a;
          }
        }
        return !1;
      }
    }]) && i(n.prototype, u), l && i(n, l), e;
  }();
  e.AbstractList = u;
}, function (t, e, n) {
  "use strict";

  function r(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.AbstractParser = void 0;
  var o = function () {
    function t(e) {
      var n, r, o;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), o = null, (r = "_input") in (n = this) ? Object.defineProperty(n, r, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[r] = o;
      var i = this.constructor.name;
      if ("AbstractParser" === this.constructor.name) throw new TypeError("Abstract class '".concat(i, "' cannot be instantiated on its own."));
      for (var a = [["parse", null]], s = 0; s < a.length; s++) {
        var c = a[s];
        if (void 0 === this[c[0]]) throw c[1] || (c[1] = ""), new TypeError("Classes extending '".concat(i, "' must declare the '").concat(c[0], "(").concat(c[1], ")' method."));
        this[c[0]] = this[c[0]].bind(this);
      }
      this._input = e;
    }
    var e, n, o;
    return e = t, (n = [{
      key: "toString",
      value: function value() {
        return "[object ".concat(this.constructor.name, "]");
      }
    }, {
      key: "input",
      get: function get() {
        return this._input;
      },
      set: function set(t) {
        this._input = t;
      }
    }]) && r(e.prototype, n), o && r(e, o), t;
  }();
  e.AbstractParser = o;
}, function (t, e, n) {
  "use strict";

  function r(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function o(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.AbstractRequestHandler = void 0;
  var i = function () {
    function t(e) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), o(this, "_baseUrl", null), o(this, "_headers", {}), o(this, "_dataInterceptors", []), o(this, "_errorInterceptors", []), o(this, "_resultInterceptors", []);
      var n = this.constructor.name;
      if ("AbstractRequestHandler" === this.constructor.name) throw new TypeError("Abstract class '".concat(n, "' cannot be instantiated on its own."));
      for (var r = [["request", "url, data, method"]], i = 0; i < r.length; i++) {
        var a = r[i];
        if (void 0 === this[a[0]]) throw a[1] || (a[1] = ""), new TypeError("Classes extending '".concat(n, "' must declare the '").concat(a[0], "(").concat(a[1], ")' method."));
        this[a[0]] = this[a[0]].bind(this);
      }
      this._setBaseUrl(e);
    }
    var e, n, i;
    return e = t, (n = [{
      key: "addDataInterceptor",
      value: function value(t) {
        if ("function" == typeof t) {
          var e = this.dataInterceptors.push(t);
          return "number" == typeof e ? e - 1 : 0;
        }
        return !1;
      }
    }, {
      key: "applyDataInterceptors",
      value: function value(t) {
        for (var e = 0; e < this.dataInterceptors; e++) t = this.dataInterceptors[e](t);
        return t;
      }
    }, {
      key: "removeDataInterceptor",
      value: function value(t) {
        return !(!this.dataInterceptors[t] || "function" != typeof this.dataInterceptors[t]) && (this.dataInterceptors.splice(t, 1), !0);
      }
    }, {
      key: "addErrorInterceptor",
      value: function value(t) {
        if ("function" == typeof t) {
          var e = this.errorInterceptors.push(t);
          return "number" == typeof e ? e - 1 : 0;
        }
        return !1;
      }
    }, {
      key: "applyErrorInterceptors",
      value: function value(t) {
        for (var e = 0; e < this.errorInterceptors; e++) t = this.errorInterceptors[e](t);
        return t;
      }
    }, {
      key: "removeErrorInterceptor",
      value: function value(t) {
        return !(!this.errorInterceptors[t] || "function" != typeof this.errorInterceptors[t]) && (this.errorInterceptors.splice(t, 1), !0);
      }
    }, {
      key: "addResultInterceptor",
      value: function value(t) {
        if ("function" == typeof t) {
          var e = this.resultInterceptors.push(t);
          return "number" == typeof e ? e - 1 : 0;
        }
        return !1;
      }
    }, {
      key: "applyResultInterceptors",
      value: function value(t) {
        for (var e = 0; e < this.resultInterceptors; e++) t = this.resultInterceptors[e](t);
        return t;
      }
    }, {
      key: "removeResultInterceptor",
      value: function value(t) {
        return !(!this.resultInterceptors[t] || "function" != typeof this.resultInterceptors[t]) && (this.resultInterceptors.splice(t, 1), !0);
      }
    }, {
      key: "addHeader",
      value: function value(t, e) {
        return this._headers[t] = e, this;
      }
    }, {
      key: "clearHeaders",
      value: function value() {
        return this.headers = {}, this;
      }
    }, {
      key: "removeHeader",
      value: function value(t) {
        return delete this.headers[t], this;
      }
    }, {
      key: "setDefaultHeaders",
      value: function value() {
        return this.headers = {
          "Content-Type": "application/x-www-form-urlencoded;charset-UTF-8"
        }, this;
      }
    }, {
      key: "isMethodValid",
      value: function value(t) {
        return /(POST|GET|PUT|DELETE|HEAD|CONNECT|OPTIONS|TRACE)/.test(t);
      }
    }, {
      key: "isValidEndpoint",
      value: function value(t) {
        return "string" == typeof t && /^\/?([^\/\r\n]+\/?)+$/i.test(t.trim());
      }
    }, {
      key: "isValidUrl",
      value: function value(t) {
        return "string" == typeof t && /^(https?:\/\/)([^\/]+\/?)+$/i.test(t.trim());
      }
    }, {
      key: "trimSlashes",
      value: function value(t) {
        return t.replace(/(^\/|\/$)/g, "");
      }
    }, {
      key: "_setBaseUrl",
      value: function value(t) {
        if (!this.isValidUrl(t)) throw new TypeError("'".concat(t, "' is not a valid URL."));
        this._baseUrl = /\/$/.test(t.trim()) ? t.trim() : t.trim() + "/";
      }
    }, {
      key: "baseUrl",
      get: function get() {
        return this._baseUrl;
      },
      set: function set(t) {
        this._setBaseUrl(t);
      }
    }, {
      key: "headers",
      get: function get() {
        return this._headers;
      },
      set: function set(t) {
        this._headers = t;
      }
    }, {
      key: "dataInterceptors",
      get: function get() {
        return this._dataInterceptors;
      },
      set: function set(t) {
        for (var e = 0; e < t.length; e++) if ("function" != typeof t[e]) throw new TypeError("Invalid interceptor provided. Not a valid callable.");
        this._dataInterceptors = t;
      }
    }, {
      key: "errorInterceptors",
      get: function get() {
        return this._errorInterceptors;
      },
      set: function set(t) {
        for (var e = 0; e < t.length; e++) if ("function" != typeof t[e]) throw new TypeError("Invalid interceptor provided. Not a valid callable.");
        this._errorInterceptors = t;
      }
    }, {
      key: "resultInterceptors",
      get: function get() {
        return this._resultInterceptors;
      },
      set: function set(t) {
        for (var e = 0; e < t.length; e++) if ("function" != typeof t[e]) throw new TypeError("Invalid interceptor provided. Not a valid callable.");
        this._resultInterceptors = t;
      }
    }]) && r(e.prototype, n), i && r(e, i), t;
  }();
  e.AbstractRequestHandler = i;
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.AbstractStore = void 0;
  e.AbstractStore = function t() {
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t);
    var e = this.constructor.name;
    if ("AbstractStore" === this.constructor.name) throw new TypeError("Abstract class '".concat(e, "' cannot be instantiated on its own."));
    for (var n = [["get", "key"], ["getAll", null], ["set", "key, value"], ["remove", "key"], ["clear", null]], r = 0; r < n.length; r++) {
      var o = n[r];
      if (void 0 === this[o[0]]) throw o[1] || (o[1] = ""), new TypeError("Classes extending '".concat(e, "' must declare the '").concat(o[0], "(").concat(o[1], ")' method."));
      this[o[0]] = this[o[0]].bind(this);
    }
  };
}, function (t, e, n) {
  "use strict";

  function r(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.AbstractValidation = void 0;
  var o = function () {
    function t(e) {
      var n, r, o;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), o = null, (r = "_input") in (n = this) ? Object.defineProperty(n, r, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[r] = o;
      var i = this.constructor.name;
      if ("AbstractValidation" === this.constructor.name) throw new TypeError("Abstract class '".concat(i, "' cannot be instantiated on its own."));
      for (var a = [["validate", null], ["message", null]], s = 0; s < a.length; s++) {
        var c = a[s];
        if (void 0 === this[c[0]]) throw c[1] || (c[1] = ""), new TypeError("Classes extending '".concat(i, "' must declare the '").concat(c[0], "(").concat(c[1], ")' method."));
        this[c[0]] = this[c[0]].bind(this);
      }
      this._input = e;
    }
    var e, n, o;
    return e = t, (n = [{
      key: "toJSON",
      value: function value() {
        var t = !!this.hasOwnProperty("validation") && this.validation(),
          e = this.hasOwnProperty("message") ? this.message() : "";
        return {
          input: this.input,
          validation: t || !1,
          message: e || null
        };
      }
    }, {
      key: "toString",
      value: function value() {
        return "[object ".concat(this.constructor.name, "]");
      }
    }, {
      key: "input",
      get: function get() {
        return this._input;
      },
      set: function set(t) {
        this._input = t;
      }
    }]) && r(e.prototype, n), o && r(e, o), t;
  }();
  e.AbstractValidation = o;
}]);